import { Pagination, SensorType } from '@innovyze/shared-utils';
import { STATUS_ENUM } from './reducers.types';

export interface ListSensorGroupsParams {
	limit?: number;
	offset?: number;
	searchQuery?: string;
	sortBy?: string;
	sensorType?: SensorType;
	includeSensorGroupPairs?: string;
	sensorGroupIds?: string;
}

export interface SensorGroupPair {
	_id: string;
	createDate: Date;
	createdBy: string;
	sensorId: string;
	sensorGroupConfig: string;
}

export interface SensorGroupConfig {
	_id: string;
	createdBy: string;
	sensorType: SensorType;
	createDate: string;
	lastModifiedDate: string;
	lastModifiedBy: string;
	name: string;
	sensorGroupPairs?: SensorGroupPair[];
}

export interface PaginatedSensorGroups {
	sensorGroups: SensorGroupConfig[];
	pagination?: Pagination;
	status: STATUS_ENUM;
}

export interface SensorGroupStoreState {
	sensorGroups: PaginatedSensorGroups;
}
